import {
  DRIVER_APP_VERSION_CODE,
} from "../appVersion.js";

import {
  isDriverAndroidNativeRuntime,
} from "./appVersionTransport.js";

// REISOR_ANDROID_1_0_87_MANDATORY_UPDATE_POLICY_CLIENT_V2

const REMOTE_API_ORIGIN =
  "https://backend.cargo-platform.online";

export async function
fetchDriverAppVersionPolicy({
  timeoutMs = 6500,
} = {}) {
  // Android update policy must never control the normal web Driver HUB.
  if(
    !isDriverAndroidNativeRuntime()
  ){
    return null;
  }

  const controller=
    new AbortController();

  const timeoutId=
    window.setTimeout(
      () => {
        try {
          controller.abort();
        } catch {}
      },
      timeoutMs
    );

  try {
    const params=
      new URLSearchParams({
        versionCode:
          String(
            DRIVER_APP_VERSION_CODE
          ),

        platform:
          "android",

        ts:
          String(
            Date.now()
          ),
      });

    const response=
      await fetch(
        `${REMOTE_API_ORIGIN}/api/app-version-policy/driver?${params.toString()}`,
        {
          method: "GET",
          cache: "no-store",
          credentials: "include",
          signal: controller.signal,
        }
      );

    const data=
      await response
        .json()
        .catch(() => ({}));

    if(
      !response.ok ||
      data?.ok !== true ||
      !data?.policy
    ){
      const error=
        new Error(
          data?.error ||
          `HTTP_${response.status}`
        );

      error.status=
        response.status;

      throw error;
    }

    return data.policy;
  } finally {
    window.clearTimeout(
      timeoutId
    );
  }
}
